import styled from "styled-components";

const Card = styled.main`
  background-color: ivory;
  padding: 24px;
  border-radius: 20px;
  max-width: 600px;
  max-height: 800px;
  display: flex;
  align-items: stretch;
  flex: 1;
`;

export default Card;
